import { Navigate, Outlet, useSearchParams } from 'react-router';
import { useSession } from '@/app/providers/SessionProvider';
import { loginPathFor, readRequestId } from '@/lib/pendingRequest';

/**
 * Pathless route guard (routing.md rule 8) — redirects a signed-out visitor
 * to `/login`, preserving the pending request id if there is one. `replace`
 * so Back does not bounce between the guard and the login screen.
 *
 * Generic and reusable for a future dashboard — it knows nothing about
 * consent.
 */
export function RequireSession() {
    const { status } = useSession();
    const [searchParams] = useSearchParams();

    if (status === 'signed-out') {
        return (
            <Navigate to={loginPathFor(readRequestId(searchParams))} replace />
        );
    }

    return <Outlet />;
}
